'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        resizableContent: {
            type: Boolean,
            kComposite: 'resizable.content'
        },
        resizableMin: {
            type: Number,
            kComposite: 'resizable.min'
        },
        resizableMax: {
            type: Number,
            kComposite: 'resizable.max'
        },
        resizableToolbar: {
            type: Boolean,
            kComposite: 'resizable.toolbar'
        }
    }
};